import React from 'react'
import { withLogin } from 'elentari'
import { useLocation } from 'react-router-dom'
import LoginBase from './LoginBase'
import { BRAND } from '../../branding'

const Login = withLogin(LoginBase)

const CustomLogin = ({ history }) => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const redirectPath = params.get('redirectPath')
  return (
    <Login
      logo={
        <img
          alt={BRAND.name}
          src={BRAND.logo}
          style={{ height: 38, marginBottom: 60 }}
        />
      }
      history={history}
      redirectPath={redirectPath}
    />
  )
}

export default CustomLogin
